import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LoadingMaskService } from '../../../../../../shared/loading-mask/loading-mask.service';
import { HeadendSummaryService, HeadendSummary } from '../../../shared/headend-summary.service';

@Injectable()
export class AuthorizationSummaryResolve implements Resolve<HeadendSummary> {
	constructor(private service: HeadendSummaryService,
	            private mask: LoadingMaskService) {
	}

	resolve(route: ActivatedRouteSnapshot): Promise<HeadendSummary> {
		this.mask.addLoading();
		return this.service.getSummary()
			.then((summary: HeadendSummary) => {
				this.mask.removeLoading();
				return summary;
			});
	}
}